const css = `.no-auth-page-template {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100dvh;
  width: 100%;
  padding: var(--space-4);
}
.no-auth-page-template .no-auth-page-icon {
  height: 48px;
  width: 48px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: var(--space-4);
  color: var(--surface-raised);
  background-color: var(--accent);
}
.no-auth-page-template .no-auth-page-icon i {
  font-size: var(--font-size-2xl);
}
.no-auth-page-template .logo img {
  width: 120px;
  height: 120px;
  filter: var(--logo-filter);
}
.no-auth-page-template .gradient-border {
  background: linear-gradient(180deg, var(--accent) 10%, transparent 30%);
  border-radius: 48px;
  padding: var(--space-1);
  width: 100%;
  max-width: 580px;
  margin-bottom: var(--space-7);
}
.no-auth-page-template.error .gradient-border {
  background: linear-gradient(var(--login-glow) 10%, transparent 30%);
}
.no-auth-page-template.error .no-auth-page-icon {
  background-color: var(--danger);
}
.no-auth-page-template.error .p-card img {
  margin-bottom: var(--space-5);
  max-width: 360px;
}
.no-auth-page-template .p-card {
  border-radius: 48px;
  padding: var(--space-8);
  box-shadow: unset;
}
.no-auth-page-template .p-card .p-card-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.no-auth-page-template .p-card .p-card-content p {
  margin-top: var(--space-4);
  margin-bottom: var(--space-6);
}
.no-auth-page-template .p-card .p-card-content form {
  gap: var(--space-5);
}
.no-auth-page-template .p-card .p-card-content .form-field {
  width: 100%;
}
.no-auth-page-template .p-card .p-card-content .form-field label {
  font-size: var(--font-size-lg);
}
.no-auth-page-template .p-card .p-card-content .p-button-link {
  margin-left: auto;
  width: min-content;
  height: min-content;
}
.no-auth-page-template .p-card .p-card-content .p-button.large {
  width: 100%;
}

@media (max-width: 768px) {
  .no-auth-page-template .p-card {
    padding: var(--space-8);
  }
  .no-auth-page-template.error .p-card .p-image {
    display: block;
    max-width: min(360px, 100%);
  }
  .no-auth-page-template.error .p-card img {
    max-width: min(360px, 100%);
    height: auto;
  }
  .no-auth-page-template.error .p-card .p-card-content .p-button-link,
  .no-auth-page-template .p-card .p-card-content .p-button.large + .p-button-link {
    margin-left: auto;
    margin-right: auto;
  }
}
@media (max-width: 480px) {
  .no-auth-page-template {
    padding: 0 var(--space-2);
  }
  .no-auth-page-template .p-card {
    padding: var(--space-7) var(--space-6);
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
